export default __webpack_public_path__ + "static/Beaumont-Phua-Resume-431ff5d734d011f6f947f3d9eb5f61cb.pdf";